export default {
  methods: {
    numberWithSpaces(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
    },

    numberWithPlus(value) {
      if (this.isPlus(value)) {
        return `+${value}`
      }

      return value
    },

    signClass(value) {
      return {
        plus: this.isPlus(value),
        minus: this.isMinus(value)
      }
    },

    isPlus(value) {
      return value > 0;
    },

    isMinus(value) {
      return !this.isPlus(value)
    }
  }
}